import { z } from 'zod';
import { companyRegionDetailSchema } from '@/schemas/companyRegionSchema';
import { agentDetailSchema } from '@/schemas/agentSchema';
import { companyDetailSchema } from '@/schemas/companySchema';
import { officeDetailSchema } from '@/schemas/officeSchema';

export type RegionDataType = z.infer<typeof regionDataSchema>;

const regionShortnameRegex = /^[A-Za-z\-äöåÄÖÅ]+$/;

export const regionShortnameSchema = z
  .string()
  .min(2, 'Region must be at least 2 characters')
  .max(50, 'Region must be max 50 characters')
  .regex(regionShortnameRegex, 'Invalid region');

export const regionDataSchema = z.object({
  companyRegion: companyRegionDetailSchema.optional(),
  agents: z.array(agentDetailSchema),
  offices: z.array(officeDetailSchema),
  companies: z.array(companyDetailSchema),
});
